<script>
export default {
    name: 'PasswordUpdateForm',
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {}
    },
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <form-group name="password" :label="$t('password')">
            <b-form-input
                v-model="form.password"
                class="border-primary rounded"
                slot-scope="{ attrs, listeners }"
                type="password"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="repeat_password" :label="$t('repeat_password')">
            <b-form-input
                v-model="form.repeat_password"
                class="border-primary rounded"
                slot-scope="{ attrs, listeners }"
                type="password"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>          
        </form-wrapper>
    </b-form>
</template>